/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Delete_AriaInputs */



/**
* | output |
* | --- |
* | "Delete Record" |
*
* @param {Explorer_Info_Delete_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_delete_aria = /** @type {((inputs?: Explorer_Info_Delete_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Delete_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer l'enregistrement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Datensatz löschen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elimina record")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить запись")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar registro")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("删除记录")
	if (locale === "ja") return /** @type {LocalizedString} */ ("レコードを削除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रिकॉर्ड हटाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Excluir registro")
	return /** @type {LocalizedString} */ ("Delete Record")
});